/**
 * Copyright (C) 2018-present, Botobag Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { ActionTree } from 'vuex';

import { ProductVariant } from '@/models';

import api, {
  DraftFulfillmentInput,
} from '@/api';

import {
  CartState,

  LOAD_CART_ACTION,
  ADD_CART_ITEM_ACTION,
  SET_CART_ITEM_QUANTITY_ACTION,
  SET_CART_FULFILLMENTS_ACTION,
  SET_CART_MUTATION,
} from './types';
import { RootState } from '../../types';

export const actions: ActionTree<CartState, RootState> = {
  [LOAD_CART_ACTION]({ commit, state }) {
    // TODO: Handle errors.
    const cart = (state.cart) ? api.fetchDraftOrder(state.cart.id) : api.createDraftOrder({});
    cart.then((data) => (commit(SET_CART_MUTATION, data)));
  },

  [ADD_CART_ITEM_ACTION]({ commit, state }, payload: {
    variant: ProductVariant,
    quantity: number,
  }) {
    // TODO: Handle errors.
    api.addCartItem(state.cart, payload.variant.id, payload.quantity)
      .then((data) => (commit(SET_CART_MUTATION, data)));
  },

  [SET_CART_ITEM_QUANTITY_ACTION]({ commit, state }, payload: {
    itemId: string,
    quantity: number,
  }) {
    // TODO: Handle errors.
    api.setDraftOrderItemQuantity(state.cart!, payload.itemId, payload.quantity)
      .then((data) => (commit(SET_CART_MUTATION, data)));
  },

  [SET_CART_FULFILLMENTS_ACTION]({ commit, state }, payload: {
    fulfillments: DraftFulfillmentInput[],
  }) {
    // TODO: Handle errors.
    api.setDraftOrderFulfillments(state.cart!, payload.fulfillments)
      .then((data) => (commit(SET_CART_MUTATION, data)));
  },
};
